<route-container
  [uid]="chatbotUuid + '-' + contextVar"
>
  <loader-container
    *ngIf="chatbotUuid && contextVar"
    [loader]="loader"
    (loaded)="onLoad($event)"
    [options]="{
      contentTemplate: contextVarTemplate
    }"
  >
  </loader-container>
</route-container>

<ng-template #contextVarTemplate>
  <div *ngIf="result">
    <div *ngIf="!result.exists" class="alert alert-warning">
      <b>WARNING</b>: Variable <i>{{contextVar}}</i> is not initialized for chatbot <i>{{chatbotUuid}}</i>.
    </div>
    <div *ngIf="result.info">
      <nav mat-tab-nav-bar [tabPanel]="tabPanel">
          <a mat-tab-link
             *ngFor="let t of tabs"
             (click)="setActiveMainTab(t)"
             [active]="activeTab == t">{{t}}</a>
      </nav>
      <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
      <mat-tab-nav-panel #tabPanel>
        <div *ngIf="activeTab == 'Search'">
          <div [formGroup]="searchForm">
            <div class="row p-0 m-0">
              <div
                [ngClass]="'col-12 m-0 p-0 pe-2 mb-2'"
              >
                <mat-form-field class="d-block">
                  <mat-label>Prompt</mat-label>
                  <input matInput type="text" formControlName="prompt" class="d-block">
                </mat-form-field>
              </div>
            </div>
            <actions-container>
              <button
                mat-raised-button
                color="primary"
                (click)="searchInContext()"
                [disabled]="!searchForm.valid"
              >Match in Context</button>
            </actions-container>
          </div>
          <div *ngIf="searchResults" class="mt-4">
            <data-table
              *ngIf="searchResults.length"
              [items]="searchResults"
              [options]="{
                tableNgClass: 'text-secondary font-monospace font-size-12'
              }"
              [columnOptions]="{
                '$$raw': { hidden: true },
                'distance': { heading: 'Distance', order: 3, outerNgClass: 'text-primary' },
                'id': { heading: 'Id', order: 1, valueNgClass: 'text-secondary fw-light' },
                'entity': { heading: 'Entity Match', order: 2, renderTemplate: searchResultCellEntity }
              }"
            ></data-table>
            <div
              *ngIf="!searchResults.length"
              class="alert alert-info"
            >
              No matches found.
            </div>
          </div>
        </div>
        <div *ngIf="activeTab == 'Schema'" class="p-2">
          <div class="row p-0 m-0">
            <div class="col-12 col-md-4 col-lg-3 m-0 p-0 pe-2">
              <mat-card appearance="outlined" class="height-200">
                <mat-card-content>
                  <div class="mb-2 fw-light">
                    ID:
                    <div class="text-primary">{{result.info.schemaDef['collection_id']}}</div>
                  </div>
                  <div class="mb-2 fw-light">
                    Name:
                    <div class="text-primary">{{result.info.schemaDef['collection_name']}}</div>
                  </div>
                  <div class="text-secondary font-size-14 fw-light">
                    {{result.info.schemaDef['description']}}
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
            <div class="col-12 col-md-4 col-lg-3 m-0 p-0 pe-2">
              <mat-card appearance="outlined" class="height-200">
                <mat-card-content>
                  <div class="mb-2 fw-light">
                    Status:
                    <div class="text-primary">{{result.info.state}}</div>
                  </div>
                  <div class="mb-2 fw-light">
                    Entity Count:
                    <div class="text-primary">
                      {{result.info.stats['row_count']}}
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
            <div class="col-12 col-md-4 col-lg-3 m-0 p-0 pe-2">
              <mat-card appearance="outlined" class="height-200">
                <mat-card-content>
                  <div class="mb-2 fw-light">
                    Shards:
                    <div class="text-primary">{{result.info.schemaDef['num_shards']}}</div>
                  </div>
                  <div class="mb-2 fw-light">
                    Partitions:
                    <div class="text-primary">{{result.info.schemaDef['num_partitions']}}</div>
                  </div>
                  <div class="mb-2 fw-light">
                    Automatic ID:
                    <div class="text-primary"
                      [ngClass]="{'text-danger': !result.info.schemaDef['auto_id']}"
                    >{{result.info.schemaDef['auto_id']}}</div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
            <div class="col-12 col-md-4 col-lg-3 m-0 p-0 pe-2">
              <mat-card appearance="outlined" class="height-200">
                <mat-card-content>
                  <div class="mb-2 fw-light">
                    Consistency Level:
                    <div class="text-secondary" [ngSwitch]="result.info.schemaDef['consistency_level']">
                      <div *ngSwitchCase="2" class="text-primary">
                        Bounded
                      </div>
                      <div *ngSwitchDefault>
                        {{result.info.schemaDef['consistency_level']}}
                      </div>
                    </div>
                  </div>
                  <div class="mb-2 fw-light">
                    Features:
                    <div class="text-primary">
                      {{result.info.schemaDef['enable_dynamic_field'] ? 'Dynamic Schema' : 'Static Schema'}}
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
          <mat-card appearance="outlined" class="my-4">
            <mat-card-content>
              <data-table
                [items]="result.info.schemaDef['fields']"
                [columnOptions]="{
                  '$$raw': { hidden: true },
                  'field_id': { hidden: true },
                  'is_primary': { hidden: true },
                  'nullable': { hidden: true },
                  'defaultValue': { hidden: true },
                  'isDynamic': { hidden: true },
                  'isAutoId': { hidden: true },
                  'isNullable': { hidden: true },
                  'description': { hidden: true },
                  'type': { hidden: true },
                  'name': {
                    heading: 'Field',
                    order: 1,
                    renderTemplate: cellField
                  },
                  'params': {
                    heading: 'Type',
                    order: 2,
                    renderTemplate: cellType
                  },
                  'Index': {
                    order: 3,
                    renderTemplate: cellIndex
                  },
                  'Index Parameters': {
                    order: 4,
                    renderTemplate: cellIndexParams
                  },
                }"
              ></data-table>
            </mat-card-content>
          </mat-card>
        </div>
        <div *ngIf="activeTab == 'Data'">

          <div class="d-flex justify-content-center my-2 mx-2" *ngIf="varDataPaged">
            <button
              (click)="filterDataPrevious()"
              mat-mini-fab color="primary" [disabled]="varDataPaged.pageIndex == 0">
              <mat-icon>skip_previous</mat-icon>
            </button>
            <div class="mx-3 my-2 fw-light">
              {{varDataPaged.pageIndex + 1}} / {{varDataPaged.totalPages}}
            </div>
            <button
              (click)="filterDataNext()"
              mat-mini-fab color="primary" [disabled]="varDataPaged.pageIndex == (varDataPaged.totalPages - 1)">
              <mat-icon>skip_next</mat-icon>
            </button>
            </div>
          <loader-container
            [loader]="varDataLoader"
            [options]="{
              contentTemplate: varDataTemplate
            }"
            (loaded)="onLoadPagedData($event)"
          ></loader-container>
          <actions-container [ngClass]="'mx-4'">
            <button
              [routerLink]="['./train']"
              [disabled]="!contextVar || contextVar !== 'igy_manual_kb' && contextVar !== 'igy_glossary'"
              class="ms-2"
              mat-raised-button color="primary">
              <mat-icon>model_training</mat-icon>
              Manual Entry
            </button>
          </actions-container>
        </div>
      </mat-tab-nav-panel>
    </div>
  </div>
</ng-template>

<ng-template #varDataTemplate>
  <div *ngIf="varDataPaged">
    <div>
      <data-table
        [options]="{
          tableNgClass: 'font-size-12'
        }"
        [columnOptions]="{
          '$$raw': { hidden: true },
          'meta_usage': { hidden: true },
          'text_hash': { hidden: true },
          'id': { heading: 'ID', order: 1 },
          'text': { heading: 'Text', order: 2, renderTemplate: dataCellText },
          'source': { hidden: true },
          'tags': { hidden: true },
          'order': { heading: 'Sequence', order: 5 },
          'prompt_tokens': { hidden: true },
          'total_tokens': { heading: 'Tokens', order: 4 },
          'Actions': { order: 100, renderTemplate: cellAction }
        }"
        [items]="varDataPaged.results"></data-table>
    </div>
  </div>
</ng-template>

<ng-template #cellAction let-rowItem=rowItem>
  <button mat-mini-fab color="primary" matTooltip="Delete this entry" (click)="deleteItem(rowItem['id'])">
    <mat-icon>delete</mat-icon>
  </button>
</ng-template>

<ng-template #dataCellText let-rowItem=rowItem>
  <div>{{rowItem['text']}}</div>
  <div *ngIf="rowItem['source']" class="ps-2 pt-2">
    <span class="fw-bold">Source:</span>
    <a
      class="link-underline-light"
      target="_blank"
      href="{{rowItem['source']}}"
      *ngIf="rowItem['source'].startsWith('http')">
      {{rowItem['source']}}
    </a>
    <span *ngIf="!rowItem['source'].startsWith('http')">
      {{rowItem['source']}}
    </span>
  </div>
  <div *ngIf="rowItem['tags']" class="ps-2 pt-2">
    <span class="fw-bold">Tags:</span>
    {{rowItem['tags'] | json}}
  </div>
</ng-template>

<ng-template>

</ng-template>

<ng-template #cellField let-rowItem=rowItem>
  {{rowItem['name']}}<span *ngIf="rowItem['is_primary']"><span class="text-primary">*</span>
  (PK)</span>
  <div class="text-secondary font-size-14 fw-light">
    {{rowItem['description']}}
  </div>
  <div class="text-secondary font-size-14 fw-light" *ngIf="rowItem['isAutoId']">
    AutoId
  </div>
  <div class="text-secondary font-size-14 fw-light">
    {{rowItem['isNullable'] ? 'Nullable' : 'Required'}}
  </div>
  <div class="text-secondary font-size-14 fw-light" *ngIf="rowItem['isDynamic']">
    Dynamic
  </div>
</ng-template>

<ng-template #cellType let-rowItem=rowItem>
  <div [ngSwitch]="rowItem['type']">
    <div *ngSwitchCase="0" class="text-danger">
      NONE
    </div>
    <div *ngSwitchCase="99" class="text-danger">
      UNKNOWN
    </div>
    <div *ngSwitchCase="1">
      Bool
    </div>
    <div *ngSwitchCase="2">
      Int8
    </div>
    <div *ngSwitchCase="3">
      Int16
    </div>
    <div *ngSwitchCase="4">
      Int32
    </div>
    <div *ngSwitchCase="5">
      Int64
    </div>
    <div *ngSwitchCase="10">
      Float
    </div>
    <div *ngSwitchCase="11">
      Double
    </div>
    <div *ngSwitchCase="22">
      Array
    </div>
    <div *ngSwitchCase="23">
      Json
    </div>
    <div *ngSwitchCase="100">
      BinaryVector({{rowItem['params'] | json}})
    </div>
    <div *ngSwitchCase="101">
      FloatVector({{rowItem['params']['dim']}})
    </div>
    <div *ngSwitchCase="102">
      Float16Vector({{rowItem['params']['dim']}})
    </div>
    <div *ngSwitchCase="20">
      String({{rowItem['params'] | json}})
    </div>
    <div *ngSwitchCase="21">
      VarChar({{rowItem['params']['max_length']}})
    </div>
    <div *ngSwitchDefault>
      {{rowItem['type']}}: {{rowItem['params']}}
    </div>
  </div>
  <div *ngIf="rowItem['defaultValue']" class="font-size-12">
    <span class="me-2">Default:</span>
    <span class="text-primary">{{rowItem['defaultValue']['long']}}</span>
  </div>
</ng-template>

<ng-template #cellIndex let-rowItem=rowItem>
  <div *ngFor="let indexDef of schemaFieldToIndexMap[rowItem['name']]">
    <div>{{indexDef['index_name']}}</div>
    <div class="badge bg-primary">
      {{indexDef['index_type']}}
    </div>
  </div>
</ng-template>

<ng-template #cellIndexParams let-rowItem=rowItem>
  <div *ngFor="let indexDef of schemaFieldToIndexMap[rowItem['name']]">
    <ul>
      <li>nlist: {{indexDef['nlist']}}</li>
      <li>metric_type: {{indexDef['metric_type']}}</li>
      <li>indexed_rows: {{indexDef['indexed_rows']}} / {{indexDef['total_rows']}}</li>
      <li>pending_index_rows: {{indexDef['pending_index_rows']}} / {{indexDef['total_rows']}}</li>
      <li>state: {{indexDef['state']}}</li>
    </ul>
  </div>
</ng-template>

<ng-template #searchResultCellEntity let-cellItem=cellItem>
  <div class="text-secondary fw-light">
    {{cellItem['text']}}
  </div>
</ng-template>
